import {
  UserScopedLocalStorageKey,
  UserScopedValue
} from 'shared/types/localStorage'

import { lsGetItem } from './lsGetItem'

export const lsGetUserItem = <K extends UserScopedLocalStorageKey>(
  key: K,
  userId: string
): UserScopedValue<K> | null => {
  const all = lsGetItem(key) as Record<string, UserScopedValue<K>> | null
  return all?.[userId] ?? null
}
